import { truckModelService } from '_services';
import { session } from '_helpers';
import { ACTIONS_TRUCK_MODEL } from '_constants/truckModel.constants';
import alertActions from './alert.actions';

export const receiveTruckModels = (truckModels) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < truckModels.length; i++) {
    byIdObjectToDispatch[truckModels[i].truckModelID] = truckModels[i];
  }

  return {
    type: ACTIONS_TRUCK_MODEL.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteTruckModel = (truckModelId) => ({
  type: ACTIONS_TRUCK_MODEL.DELETE,
  byId: { [truckModelId]: null }
});

const getTruckModels = (accountID) => async (dispatch) => {
  try {
    const resp = await truckModelService.getAll(accountID);
    if (resp?.[0]?.truckModelID) {
      dispatch(receiveTruckModels(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving truck models.', e));
  }
  return null;
};

const getTruckModel = (truckModelID) => async (dispatch) => {
  try {
    const resp = await truckModelService.getById(truckModelID);
    if (resp?.truckModelID) {
      dispatch(receiveTruckModels([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving truck model #${truckModelID}.`, e));
  }
  return null;
};

const addTruckModel = (truckModel) => async (dispatch) => {
  try {
    const resp = await truckModelService.create(truckModel);
    if (resp?.truckModelID) {
      dispatch(receiveTruckModels([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updTruckModel = (truckModel) => async (dispatch) => {
  try {
    const resp = await truckModelService.update(truckModel);
    if (resp?.truckModelID) {
      dispatch(receiveTruckModels([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delTruckModel = (truckModelID) => async (dispatch) => {
  try {
    const resp = await truckModelService.delete(truckModelID);
    if (resp?.truckModelID) {
      dispatch(deleteTruckModel(resp.truckModelID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing truck model #${truckModelID}.`, e));
  }
  return null;
};

const truckModelActions = {
  getTruckModels,
  getTruckModel,
  addTruckModel,
  updTruckModel,
  delTruckModel,
};

export default truckModelActions;
